import angular from 'angular';
import Vue from 'vue';
import Subgroups from './Subgroups.vue';
import SubgroupForm from './SubgroupForm.vue';
import AddSubgroupWrapper from './AddSubgroupWrapper.vue';

// Export Vue components for direct import
export {
  Subgroups,
  SubgroupForm,
  AddSubgroupWrapper,
};

// Register Vue components with Angular
const subgroupModule = angular.module('adminPanel.adminEntities.subgroups', ['ngVue'])
  .value(AddSubgroupWrapper.name, AddSubgroupWrapper)
  .directive('subgroups', ['createVueComponent', function(createVueComponent) {
    return createVueComponent(Vue.component('subgroups', Subgroups));
  }]).name;

export default subgroupModule;